import React from 'react';

import TextField from '../../../../forms/TextField';

interface AdSystemProps {
  readOnly?: boolean;
}

export default function AdSystem({ readOnly = false }: AdSystemProps) {
  return <TextField name="videoAd.adSystem" label="Ad System" inputProps={{ readOnly }} />;
}
